import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import axios from 'axios'
import router from './router'
import store from './store'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(ElementUI)
Vue.use(BootstrapVue)

Vue.prototype.$axios = axios
// 判断为开发环境加api参数,node服务器做转发
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api' : '',
Vue.prototype.$domainPrefix = process.env.NODE_ENV == 'development' ? 'http://127.0.0.1:8000/media/' : '/media/',
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
